import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
import Plus from "../../assets/plus.svg";
import RulesEditButton from "../../components/RulesEditButton";
import ListViewer from "../../components/ListViewer";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

export default class RulesPurchase extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [
        {
          headerName: "عنوان",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مدت اعتبار",
          field: "timeSpan",
          cellRenderer: "formatDay",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعيت",
          field: "isActive",
          valueFormatter: this.formatActiveContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "حداقل ميزان خريد",
          field: "minPurchase",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع سرویس",
          field: "invoiceServiceType",
          valueFormatter: this.formatServices,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "ویرایش",
          field: "id",
          cellRenderer: "fotmatEditCell",
          cellRendererParams: { editItem: this.editItem.bind(this) },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        fotmatEditCell: RulesEditButton,
        formatCurrency: this.formatCurrency,
        formatDay: this.formatDay,
      },
      ModalShow: false,
      ModalShow2: false,
      modalType: 0,
      writingProgress: false,
      NameErrorText: "",
      NameValue: "",
      IsActive: true,
      MinPurchaseErrorText: "",
      MinPurchaseValue: "",
      CreditErrorText: "",
      CreditValue: "",
      TimeSpanErrorText: "",
      TimeSpanValue: "",
      insideCheck: false,
      packCheck: false,
      sendCheck: false,
      InvoiceServiceType: [],
      AccountGroupIdBatch: [],
      ProductCategoryIdBatch: [],
      dataLoading: true,
      currentPage: 1,
      totalPages: 0,
      groupList: [],
      productList: [],
      currentList: [],
      currentListTypeIsGroup: true,
      currentRestaurantId: null,
      currentGroupList: [],
      currentProductList: [],
      Menu: [],
      priceUnit: "",
    };

    this.tableGrid = React.createRef();
    this.tableContainer = React.createRef();

    this.GetRulesPurchase = this.GetRulesPurchase.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.onCustomerGroupsClick = this.onCustomerGroupsClick.bind(this);
    this.onProductCategory = this.onProductCategory.bind(this);
  }

  formatDay(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={false}
          suffix={" روز"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatServices(params) {
    let text = "";
    params.value.forEach((element) => {
      if (element === 0) {
        if (text === "") text = "داخلی";
        else text += " ، داخلی";
      } else if (element === 1) {
        if (text === "") text = "بسته‌بندی";
        else text += " ، بسته‌بندی";
      } else if (element === 2) {
        if (text === "") text = "ارسال";
        else text += " ، ارسال";
      }
    });
    if (text === "") text = "هیچکدام";
    return text;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      // const aa=(params.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnit}
        />
      );
      //return <div style={{display:'flex',flexDirection:'row'}}><div>ریال&nbsp;</div><NumericFormat style={{fontFamily:'SFUIDisplayBold'}} value={params.value} displayType={'text'} thousandSeparator={true}/></div>
    } catch (error) {
      return "-";
    }
  }

  formatActiveContent(params) {
    if (params.value) return "فعال";
    else return "غیرفعال";
  }

  fotmatEditCell(params) {
    return;
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.GetRulesPurchase(1);
              this.onCustomerGroupsClick();
              this.onProductCategory();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getBusinessInfo();
  }

  GetRulesPurchase(page) {
    this.setState({ dataLoading: true });
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/RulePurchase/GetRulesPurchase?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          console.log(res);
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        if (!result.isSuccessfull) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }

        this.setState({
          dataLoading: false,
          rowData: result.results[0].items,
          currentPage: result.results[0].currentPage,
          totalPages: result.results[0].totalPages,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    this.GetRulesPurchase(1);
  }

  onPreviousPageClick() {
    this.GetRulesPurchase(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.GetRulesPurchase(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.GetRulesPurchase(this.state.totalPages);
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = this.tableGrid.current.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        // console.log('width',width);
        // console.log('tableContainer',this.tableContainer.current.getBoundingClientRect().width-10);
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          // console.log('def',def);
          if (def > cols.length) {
            let newwidth = def / cols.length;
            // console.log('newwidth',newwidth)
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            // console.log('aa');
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
        // if (width<this.tableContainer.current.getBoundingClientRect().width) params.api.sizeColumnsToFit()
      }, 50);
    } catch (error) {}
  }

  resetModalValues(id) {
    this.setState(
      {
        writingProgress: false,
        NameErrorText: "",
        NameValue: "",
        IsActive: true,
        MinPurchaseErrorText: "",
        MinPurchaseValue: "",
        CreditErrorText: "",
        CreditValue: "",
        TimeSpanErrorText: "",
        TimeSpanValue: "",
        insideCheck: false,
        packCheck: false,
        sendCheck: false,
        // groupList: [],
        // productList: [],
        currentList: [],
        currentListTypeIsGroup: true,
      },
      () => {
        this.state.rowData.forEach((element) => {
          if (element.id === id) {
            element.invoiceServiceType.forEach((element1) => {
              switch (element1) {
                case 0: {
                  this.setState({ insideCheck: true });
                  break;
                }
                case 1: {
                  this.setState({ packCheck: true });
                  break;
                }
                case 2: {
                  this.setState({ sendCheck: true });
                  break;
                }
                default:
                  break;
              }
            });
            this.setState({
              NameValue: element.name,
              IsActive: element.isActive,
              TimeSpanValue: element.timeSpan,
              groupList: element.accountGroupIdBatch,
              productList: element.productCategoryIdBatch,
              MinPurchaseValue: element.minPurchase,
              CreditValue: element.credit,
            });
          }
        });
      }
    );
  }

  onAddNewButton() {
    this.resetModalValues(0);
    this.setState({ ModalShow: true, modalType: 0 });
  }

  editItem(e) {
    this.resetModalValues(e);
    this.setState({ ModalShow: true, modalType: e });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (!this.state.NameValue) {
      this.setState({ NameErrorText: "نام شرط نمی‌تواند خالی باشد" }, () => {
        toast.error(this.state.NameErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ NameErrorText: "" });
    }

    if (!this.state.TimeSpanValue) {
      this.setState(
        { TimeSpanErrorText: "مدت زمان نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.TimeSpanErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ TimeSpanErrorText: "" });
    }

    if (!this.state.CreditValue) {
      this.setState(
        { CreditErrorText: "میزان اعتبار نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.CreditErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ CreditErrorText: "" });
    }

    if (!this.state.MinPurchaseValue) {
      this.setState(
        { MinPurchaseErrorText: "حداقل خرید نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.MinPurchaseErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ MinPurchaseErrorText: "" });
    }

    let services = [];
    if (this.state.insideCheck) services.push(0);
    if (this.state.packCheck) services.push(1);
    if (this.state.sendCheck) services.push(2);

    let data = [
      {
        restaurantId: Number(this.state.currentRestaurantId),
        id: this.state.modalType,
        name: this.state.NameValue,
        timeSpan: this.state.TimeSpanValue,
        minPurchase: Number(this.state.MinPurchaseValue),
        credit: Number(this.state.CreditValue),
        isActive: this.state.IsActive,
        invoiceServiceType: services,
        accountGroupIdBatch: this.state.groupList,
        productCategoryIdBatch: this.state.productList,
      },
    ];
    console.log(data);

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    this.setState({ writingProgress: true });
    fetch("https://94.101.187.196/api/RulePurchase/AddOrUpdateRulePurchase", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          toast.success(
            this.state.modalType === 0
              ? "شرط با موفقیت اضافه شد"
              : "شرط با موفقیت ویرایش شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            this.GetRulesPurchase(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  onCustomerGroupsClick() {
    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    fetch(
      "https://94.101.187.196/api/AccountGroup/GetAccountGroups?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=0",
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log(result);
        // if (!result.isSuccessfull) {
        //   toast.error(result.errorMessage, {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //     hideProgressBar: true,
        //     autoClose: 8000,
        //     toastClassName: "toast",
        //   });
        // }

        this.setState({
          listLoading: false,
          currentGroupList: result.results[0].items
            ? result.results[0].items
            : [],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  onProductCategory() {
    // let data1 = isUser
    //   ? {
    //       businessCode: this.props.match.params.id,
    //     }
    //   : {};
    // data1 = Object.assign(data1, ClubAuthorization());
    // let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    // fetch(
    //   "https://94.101.187.196/api/ProductCategory/GetProductCategories?restaurantId=" +
    //     this.state.currentRestaurantId,
    //   {
    //     method: "GET",
    //     headers: { Authorization: jsonString },
    //   }
    // )
    //   .then((res) => {
    //     if (res.status === 401) {
    //       LogoutFunction();
    //     } else {
    //       return res.json();
    //     }
    //   })
    //   .then((result) => {
    //     console.log(result);
    //     this.setState({
    //       listLoading: false,
    //       currentProductList: result.results ? result.results : [],
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ listLoading: false });
    //   });

    let data = {
      type: "getMenuWithBusinessCode",
      languageId: this.state.defaultLanguage,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenu:", result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let menu = JSON.parse(JSON.stringify(result.result));
            menu.forEach((element) => {
              let catname = "";
              element.nameObj.forEach((element1) => {
                if (element1.languageId === 1) {
                  catname = element1.name;
                }
              });

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (element1.languageId === this.state.defaultLanguage) {
                    catname = element1.name;
                  }
                });
              }

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (catname === "" && element1.name !== "") {
                    catname = element1.name;
                  }
                });
              }

              element.name = catname;
            });

            console.log("menu: ", menu);
            this.setState({ listLoading: false, currentProductList: menu });
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }

        this.setState({ listLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ listLoading: false });
      });
  }

  onConfirmGroups(list) {
    console.log(list);
    this.setState({ groupList: list, ModalShow2: false });
  }

  onConfirmCategory(list) {
    this.setState({ productList: list, ModalShow2: false });
  }

  render() {
    return (
      <div className="Login">
        <div className="header">
          <div
            onClick={this.onBack.bind(this)}
            className="linkStyle backButton"
          >
            <img
              src={Back}
              alt=""
              className="backButtonIcon"
              style={{ transform: "rotate(180deg)" }}
            />
            بازگشت
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "fit-content",
              alignItems: "center",
            }}
          >
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="LoginContent">
          <div className="RestaurantsListTitle">شروط خرید</div>
          <div className="RestaurantsListSubTitle">
            ایجاد و ویرایش شروط خرید
          </div>
        </div>
        <div className="pageContents" ref={this.tableContainer}>
          {!this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "fit-content",
              }}
            >
              <CustomButton
                title="شرط جدید"
                imgHeight={20}
                imgWidth={25}
                flexDirection="row-reverse"
                minHeight="35px"
                img={Plus}
                onClick={this.onAddNewButton.bind(this)}
              />
            </div>
          )}
          {!this.state.dataLoading && (
            <div className="tableContainer ag-theme-alpine">
              <AgGridReact
                enableRtl={true}
                autoHeight={true}
                animateRows={true}
                enableBrowserTooltips={true}
                tooltipMouseTrack={true}
                suppressSizeToFit={false}
                columnDefs={this.state.columnDefs}
                localeText={this.state.gridLocaleText}
                rowData={this.state.rowData}
                suppressDragLeaveHidesColumns={true}
                suppressMovable={true}
                skipHeaderOnAutoSize={false}
                // onGridReady={this.onGridReady.bind(this)}
                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                rowHeight={window.innerWidth <= 587 ? 40 : 50}
                headerHeight={window.innerWidth <= 587 ? 40 : 50}
                frameworkComponents={this.state.frameworkComponents}
                // onRowClicked={this.onGridRowClicked.bind(this)}
                // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                ref={this.tableGrid}
                enableCellTextSelection={true}
                ensureDomOrder={true}
              ></AgGridReact>
            </div>
          )}
          {!this.state.dataLoading && (
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paginator
                currentPage={this.state.currentPage}
                totalPages={this.state.totalPages}
                onFirstPageClick={this.onFirstPageClick.bind(this)}
                onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                onNextPageClick={this.onNextPageClick.bind(this)}
                onLastPageClick={this.onLastPageClick.bind(this)}
              />
            </div>
          )}

          {this.state.dataLoading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WhisperSpinner
                size={50}
                color="var(--brown1)"
                frontColor="var(--brown1)"
                backColor="var(--brown1)"
                loading={true}
              />
            </div>
          )}
        </div>

        <Modal
          show={this.state.ModalShow}
          size="md"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">
              {this.state.modalType === 0 ? "شرط جدید" : "ویرایش شرط"}
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div
                className="settingItemContainer"
                style={{ justifyContent: "flex-start" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: "1",
                    marginLeft: "10px",
                    alignItems: "center",
                  }}
                >
                  <div className="settingLabel">نام</div>
                  <Form.Control
                    maxLength="50"
                    className={
                      this.state.NameErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    placeholder="نام گروه"
                    type="text"
                    name="NameValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.NameValue}
                  />
                </div>
                <BootstrapSwitchButton
                  checked={this.state.IsActive}
                  onChange={(checked) => {
                    this.setState({ IsActive: checked });
                  }}
                  onlabel="فعال"
                  offlabel="غیرفعال"
                  onstyle="primary"
                  offstyle="warning"
                  width={75}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  مدت زمان
                </div>
                <Form.Control
                  maxLength="3"
                  className={
                    this.state.TimeSpanErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter"
                      : "inputStyleForm textAlignCenter"
                  }
                  style={{ maxWidth: "70px", direction: "ltr" }}
                  placeholder="روز"
                  type="text"
                  name="TimeSpanValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.TimeSpanValue}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  اعتبار
                </div>
                <NumericFormat
                  className={
                    this.state.CreditErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="CreditValue"
                  value={this.state.CreditValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ CreditValue: values.value });
                  }}
                />
              </div>

              <div className="settingItemContainer">
                <div className="settingLabel" style={{ whiteSpace: "noWrap" }}>
                  حداقل خرید
                </div>
                <NumericFormat
                  className={
                    this.state.MinPurchaseErrorText !== ""
                      ? "inputStyleForm inputError textAlignCenter form-control"
                      : "form-control inputStyleForm textAlignCenter"
                  }
                  // placeholder="مبلغ"
                  placeholder={this.state.priceUnit}
                  style={{ direction: "ltr", maxWidth: "120px" }}
                  type="text"
                  name="MinPurchaseValue"
                  value={this.state.MinPurchaseValue}
                  allowNegative={true}
                  displayType={"input"}
                  thousandSeparator={true}
                  isNumericString
                  onValueChange={(values) => {
                    this.setState({ MinPurchaseValue: values.value });
                  }}
                />
              </div>

              <div
                className="settingItemContainer"
                style={{
                  fontSize: "14px",
                  fontFamily: "SFUIDisplayBold",
                  direction: "ltr",
                }}
              >
                <Form.Check
                  type="checkbox"
                  label="داخلی"
                  checked={this.state.insideCheck}
                  onChange={() =>
                    this.setState({ insideCheck: !this.state.insideCheck })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="بسته بندی"
                  checked={this.state.packCheck}
                  onChange={() =>
                    this.setState({ packCheck: !this.state.packCheck })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="ارسال"
                  checked={this.state.sendCheck}
                  onChange={() =>
                    this.setState({ sendCheck: !this.state.sendCheck })
                  }
                />
              </div>

              <div
                className="settingItemContainer"
                style={{ flexDirection: "column" }}
              >
                <div style={{ width: "100%" }}>
                  <CustomButton
                    title="گروه مشترکین"
                    minHeight="35px"
                    onClick={() => {
                      this.setState({
                        ModalShow2: true,
                        listLoading: true,
                        currentListTypeIsGroup: true,
                      });
                      this.onCustomerGroupsClick();
                    }}
                  />
                </div>
                {this.state.groupList.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {this.state.groupList.map((item, i) => {
                      return this.state.currentGroupList.map((item1, i1) => {
                        if (item === item1.id) {
                          return (
                            <div
                              style={{
                                padding: "5px",
                                backgroundColor: "var(--gray1)",
                                border: "1px solid var(--brown1)",
                                borderRadius: "4px",
                                margin: "5px",
                                textAlign: "center",
                                position: "relative",
                              }}
                              key={i1}
                            >
                              {item1.name}
                              <div
                                key={i}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "var(--brown1)",
                                  position: "absolute",
                                  right: "-8px",
                                  top: "-7px",
                                  borderRadius: "50%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.groupList)
                                  );
                                  let temp = list.filter((el) => el !== item);

                                  this.setState({
                                    groupList: temp,
                                  });
                                }}
                              >
                                &#10006;
                              </div>
                            </div>
                          );
                        } else return null;
                      });
                    })}
                  </div>
                )}
              </div>
              <div
                className="settingItemContainer"
                style={{ flexDirection: "column" }}
              >
                <div style={{ width: "100%" }}>
                  <CustomButton
                    title="دسته غذایی"
                    minHeight="35px"
                    onClick={() => {
                      this.setState({
                        ModalShow2: true,
                        listLoading: true,
                        currentListTypeIsGroup: false,
                      });
                      this.onProductCategory();
                    }}
                  />
                </div>

                {this.state.productList.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginTop: "10px",
                    }}
                  >
                    {this.state.productList.map((item, i) => {
                      return this.state.currentProductList.map((item1, i1) => {
                        if (item === item1.id) {
                          return (
                            <div
                              style={{
                                padding: "5px",
                                backgroundColor: "var(--gray1)",
                                border: "1px solid var(--brown1)",
                                borderRadius: "4px",
                                margin: "5px",
                                textAlign: "center",
                                position: "relative",
                              }}
                              key={i1}
                            >
                              {item1.name}
                              <div
                                key={i}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  backgroundColor: "var(--brown1)",
                                  position: "absolute",
                                  right: "-8px",
                                  top: "-7px",
                                  borderRadius: "50%",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  let list = JSON.parse(
                                    JSON.stringify(this.state.productList)
                                  );
                                  let temp = list.filter((el) => el !== item);

                                  this.setState({
                                    productList: temp,
                                  });
                                }}
                              >
                                &#10006;
                              </div>
                            </div>
                          );
                        } else return null;
                      });
                    })}
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="ذخیره"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="md"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal2.bind(this)}
          centered
        >
          {this.state.ModalShow2 && (
            <ListViewer
              groups={this.state.currentListTypeIsGroup}
              currentSelected={
                this.state.currentListTypeIsGroup
                  ? this.state.groupList
                  : this.state.productList
              }
              listType={
                this.state.currentListTypeIsGroup ? "group" : "category"
              }
              list={
                this.state.currentListTypeIsGroup
                  ? this.state.currentGroupList
                  : this.state.currentProductList
              }
              loading={this.state.listLoading}
              onConfirmCategory={this.onConfirmCategory.bind(this)}
              onConfirmGroups={this.onConfirmGroups.bind(this)}
              hideModal={this.hideModal2.bind(this)}
            />
          )}
        </Modal>
        {/* <ReactTooltip effect="solid" /> */}
      </div>
    );
  }
}
